import { freddyTheme } from '@coolblue-development/freddy';
export const getTextAreaStyles = () => ({
    label: {
        fontWeight: freddyTheme.typography.fontWeight.dobraSlab.normal,
        marginBottom: freddyTheme.spacing[400],
    },
});
export const getButtonStyles = (selected) => ({
    cursor: 'pointer',
    padding: `${freddyTheme.spacing[200]} ${freddyTheme.spacing[300]}`,
    border: selected
        ? `1px solid ${freddyTheme.color.border.interactiveSelected}`
        : `1px solid ${freddyTheme.color.border.interactiveBase} `,
    boxShadow: selected ? `0 0 0 1px ${freddyTheme.color.border.interactiveSelected}` : 'none',
});
//# sourceMappingURL=ArticleThumbInput.styles.js.map